/** FreeSWITCH internal bridge channel id (8-char nanoid), not a dialable extension. */
const INTERNAL_BRIDGE_CHANNEL_PATTERN = /^[a-z1-9]{8}$/;

export function isInternalBridgeChannel(value: string | null | undefined): boolean {
  return Boolean(value && INTERNAL_BRIDGE_CHANNEL_PATTERN.test(value));
}

export const EAVESDROP_CALLER_ID = 'eavesdrop';

function isEavesdropMarker(value: string | null | undefined): boolean {
  return value?.toLowerCase() === EAVESDROP_CALLER_ID;
}

/** True for a supervisor listen-in channel (not a real call). */
export function isEavesdropLeg(call: {
  application?: string;
  cid_num?: string;
  callee_num?: string;
}): boolean {
  return (
    call.application === EAVESDROP_CALLER_ID ||
    call.cid_num === EAVESDROP_CALLER_ID ||
    call.callee_num === EAVESDROP_CALLER_ID
  );
}

/** True for stored CDR rows created by the eavesdrop originate leg. */
export function isEavesdropHistoryCall(call: {
  caller_id_name?: string | null;
  caller_id_number?: string | null;
  caller_display?: string | null;
}): boolean {
  return (
    isEavesdropMarker(call.caller_id_name) ||
    isEavesdropMarker(call.caller_id_number) ||
    isEavesdropMarker(call.caller_display)
  );
}
